module.exports = __webpack_public_path__ + "img/reviews-image3.7467dd65.jpg";